import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-stretch" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurrencyDropdown = _resolveComponent("CurrencyDropdown")!
  const _component_BaseInput = _resolveComponent("BaseInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CurrencyDropdown, _mergeProps({ class: "border border-r-0 border-gray-300 rounded-l" }, { required: _ctx.required }, {
      value: _ctx.currency,
      onInput: _cache[0] || (_cache[0] = (event) => _ctx.$emit('update:currency', event.target.value))
    }), null, 16, ["value"]),
    _createVNode(_component_BaseInput, _mergeProps({ class: "flex-1 rounded-l-none" }, { id: _ctx.id, placeholder: _ctx.placeholder, required: _ctx.required }, {
      type: "number",
      min: "1",
      value: _ctx.amount,
      onInput: _cache[1] || (_cache[1] = (event) => _ctx.$emit('update:amount', event.target.value))
    }), null, 16, ["value"])
  ]))
}